import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon, SmartphoneIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const plan = {
  name: '📘 100+ PROMPTS IA POUR LES FORCES DE L’ORDRE™',
  ideal: 'Idéal pour : les agents de patrouille, les enquêteurs et les superviseurs qui souhaitent protéger leur carrière et regagner du temps.',
  was: '174 €',
  now: '27',
  features: ['6 volumes SIGMA SMART™', '100+ prompts IA prêts à personnaliser', '4 bonus professionnels', 'Méthodes de structuration', 'Workflows pratiques', 'Accès numérique immédiat', '♾️ Accès à vie', 'Garantie 7 jours'],
  cta: 'Obtenir les 100+ prompts IA maintenant'
};
const trust = [{
  icon: LockIcon,
  label: 'Paiement sécurisé'
}, {
  icon: ZapIcon,
  label: 'Accès immédiat'
}, {
  icon: CreditCardIcon,
  label: 'Carte bancaire'
}, {
  icon: SmartphoneIcon,
  label: 'Ordinateur & mobile'
}];
export function Pricing() {
  return <section id="pricing" aria-label="Tarif" className="bg-radial-glow w-full scroll-mt-20 overflow-x-hidden" data-id="element-125" data-mp="3vzp6pldb6gal">
      <div className="mx-auto w-full max-w-5xl px-5 py-12" style={{
      paddingTop: "15px",
      paddingBottom: "15px"
    }} data-id="element-126" data-mp="4smecqlqi3ys">
        <div className="mx-auto mb-6 max-w-md text-center" data-id="element-127" data-mp="9tju6wj9ulx4">
          <p className="font-display text-xl font-black text-plum" data-id="element-128" data-mp="er1uxzn4xuu1">💰 Une bibliothèque complète pour un seul paiement</p>
          <p className="mt-2 text-sm font-semibold text-plum/70" data-id="element-129" data-mp="3d9qq2gvg3evc">
            🔥 Offre de lancement — disponible pour une durée limitée.
          </p>
          <p className="mt-2 inline-flex rounded-full border border-blush/40 bg-blush-soft px-4 py-1.5 text-xs font-bold text-blush-deep" data-id="element-130" data-mp="3i5picfjw9h11">
            ⚠️ Le prix repassera bientôt à 54 €
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto flex w-full max-w-md flex-col items-center overflow-hidden rounded-3xl border border-grape/30 bg-white px-6 pb-6 text-center shadow-[0_24px_60px_-28px_rgba(29,78,216,0.5)]" data-id="element-131" data-mp="2uihcnwik05yh">
          <div className="-mx-6 mb-5 w-[calc(100%+3rem)] bg-plum px-6 py-3" data-id="element-132" data-mp="318qxknzv3khf">
            <h3 className="font-display text-base font-black text-white" data-id="element-133" data-mp="2w839ob6xjjrf">{plan.name}</h3>
          </div>
          <p className="text-sm font-semibold text-plum/70" style={{
          fontSize: "12px"
        }} data-id="element-134" data-mp="28i8z60a327ac">{plan.ideal}</p>

          <div className="mt-6" data-id="element-135" data-mp="23kqmbysy37x2">
            <span className="text-[20px] font-medium text-plum/40 line-through" data-id="element-136" data-mp="2ifwvgunc7mum">{plan.was}</span>
            <div className="flex w-full justify-center py-2" data-id="element-137" data-mp="2dhd76nl9tyz3">
              <span className="relative inline-block font-display leading-none" data-id="element-138" data-mp="2dfsdt1ap0m2t">
                <span className="text-grape-shine text-[74px] font-black leading-none" style={{
                fontFamily: "Merriweather, serif"
              }} data-id="element-139" data-mp="3tu0l5omw6otv">
                  {plan.now}
                </span>
                <span className="absolute left-full top-1/2 ml-2 -translate-y-1/2 text-[45px] font-black leading-none text-grape" style={{
                fontFamily: "Merriweather, serif"
              }} data-id="element-140" data-mp="92ictxgarth">
                  €
                </span>
              </span>
            </div>
            <p className="mt-1 text-xs font-semibold text-grape" data-id="element-141" data-mp="3rh6vikvuf507">
              · Paiement unique · Accès à vie ·
            </p>
            <p className="mt-1 text-center text-[11px] font-medium text-plum/55" data-id="element-142" data-mp="j37psrj2k59i">
              · Le paiement sera traité dans votre devise locale ·
            </p>
          </div>

          <p className="mt-6 w-full text-left text-xs font-black uppercase tracking-wider text-plum" data-id="element-143" data-mp="a8b8fbp73mak">🎯 Vous recevez :</p>
          <ul className="mt-3 w-full flex-1 space-y-3 text-left" data-id="element-144" data-mp="e7sh0dzx4zjy">
            {plan.features.map(f => <li key={f} className="flex items-start gap-2.5 text-sm text-plum/80" data-id="element-145" data-mp="11xwh4bdweh67">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grape" strokeWidth={3} data-id="element-146" data-mp="16rqyv99y0m2n" />
                {f}
              </li>)}
          </ul>

          <div className="mt-7 flex w-full justify-center" data-id="element-147" data-mp="3a7w8i1pbqmgt">
            <CTAButton size="md" data-id="element-148" data-mp="3aaig21c7t1z1">{plan.cta}</CTAButton>
          </div>

          <p className="mt-3 text-[12px] font-bold text-blush" data-id="element-149" data-mp="35a45abj8bdxb">
            Économisez 147 € (-84 %)
          </p>

          <div className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-medium text-plum/55" data-id="element-150" data-mp="319k672f3i08j">
            {trust.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-151" data-mp="3szozjqku1xlw">
                <Icon className="h-4 w-4 text-grape" data-id="element-152" data-mp="3o6vvl4x6utav" />
                {label}
              </span>)}
          </div>
        </motion.div>

        <div className="mx-auto mt-12 flex w-full max-w-2xl items-start gap-3 rounded-2xl border border-grape/20 bg-white/80 p-5 text-left" data-id="element-153" data-mp="3k4ioac2smnbz">
          <ShieldCheckIcon className="mt-0.5 h-6 w-6 shrink-0 text-grape" data-id="element-154" data-mp="fs540sgmda73" />
          <p className="text-[15px] leading-relaxed text-plum/75" data-id="element-155" data-mp="1yf52ggz5qs1n">
            <span className="font-display font-bold text-plum" data-id="element-156" data-mp="1ygzojym60q7b">
              🛡️ Garantie 7 jours.
            </span>{' '}
            Découvrez le système à votre rythme. Si vous estimez que 100+ Prompts IA pour les Forces de l’Ordre™
            ne correspond pas à vos attentes, vous pouvez demander un remboursement conformément aux conditions
            de la garantie. Votre décision reste simple :{' '}
            <span className="font-bold text-plum" data-id="element-157" data-mp="2hc6hyvqc8aju">vous testez. Vous évaluez. Vous décidez.</span>
          </p>
        </div>
      </div>
    </section>;
}